const TermsAndConditionsPage = () => {
  return (
    <div>TermsAndConditionsPage</div>
  )
}

export default TermsAndConditionsPage